import {createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';
import IMeasurement from '../../interfaces/measurement.interface';

// Define a type for the slice state
export interface MeasurementsState {
  measurements:IMeasurement[]
}

// Define the initial state using that type
const initialState: MeasurementsState = {
    measurements: []
}

export const MeasurementsSlice = createSlice({
  name: 'Measurements',
  initialState,
  reducers: {
        setMeasurements: (state, {payload}:PayloadAction<IMeasurement[]>)=>{
          state.measurements = payload;
          // for(var m of state.measurements){
          //   const element = document.getElementById(m.path);
          //   if(element){
          //     element.innerHTML = m.value;
          //   }
          // }
            
        },
    }
});
    

export const { setMeasurements } = MeasurementsSlice.actions


export default MeasurementsSlice.reducer